<template>
  <div class="filter-wrapper">
    <div class="filter-container">
      <div class="actor-filter">
        <label for="actorSearch">Filter by Actor:</label>
        <input name="actorSearch" class="form-control" v-model="filters.actor.value" placeholder="*"/>
      </div>
      <div class="verb-filter">
        <label for="verbSearch">Filter by Verb:</label>
        <input name="verbSearch" class="form-control" v-model="filters.verb.value" placeholder="*"/>
      </div>
      <div class="value-filter">
        <div class="key">
          <label for="valueSearch">Value Key:</label>
          <input name="valueKey" class="form-control" v-model="filters.value.keys[0]" placeholder="*"/>
        </div>
        <div class="value">
          <label for="valueSearch">Value Search:</label>
          <input name="valueSearch" class="form-control" v-model="filters.value.value" placeholder="*"/>
        </div>
      </div>
    </div>
    <div class="filter-settings">
      <label for="showWithJsonViewer"> Show formated JSON</label>
      <input type="checkbox" name="showWithJsonViewer" v-model="settings.showJson">
    </div>
    <br/>
    <v-table :data="allEvents" class="table table-striped" :filters="filters">
    <thead slot="head">
        <v-th sortKey="timestamp.machineReadable" defaultSort="desc">Thought Jumper Events Notifiations</v-th>
    </thead>
    <tbody slot="body" slot-scope="{displayData}">
        <tr v-for="row in displayData" :key="row.id">
          <td>{{ row.actor.username }}
            <span v-if="settings.showJson">
              <json-viewer :value="row.value.title"></json-viewer>
            </span>
             <span v-else-if=" row.verb.display.en ==='VISITED'">
               visited
               <a :href='row.value.url' target="__blank">{{ row.value.title }}</a>
            </span>
             <span v-else-if=" row.verb.display.en ==='SEARCHED_PING'">
               SEARCHED_PING
               <a :href='row.value.url' target="__blank">{{ row.value.word }}</a>
            </span>
            <span v-else-if=" row.verb.display.en ==='VOICE_SEARCH'">
               VOICE_SEARCH
               <a :href='row.value.url' target="__blank">{{ row.value.searchEntity }}</a>
            </span>
            <span v-else-if=" row.verb.display.en ==='SEARCHED_FOR'">
               searched for
                {{ row.value.searchEntity }}
            </span>
            <span v-else-if=" row.verb.display.en ==='GITLAB_note_EVENT'">
               commented
                {{ row.value.note }}
            </span>
            <span v-else-if=" row.verb.display.en ==='GITLAB_issue_EVENT'">
               created an issue
               {{ row.value.title }}
                on gitlab
            </span>
            <span v-else-if=" row.verb.display.en ==='GITLAB_wiki_page_EVENT'">
               updated wikipage
                {{ row.value.title }}
                  on gitlab
            </span>
            <span v-else-if=" row.verb.display.en ==='GITLAB_pipeline_EVENT'">
               created pipeline
                {{ row.value.ref }} ( {{row.value.status}} )
                  on gitlab
            </span>
            <span v-else-if=" row.verb.display.en ==='GITLAB_push_EVENT'">
               commited changes in <a :href= 'row.value.project.web_url' target="_blank">{{ row.value.project.name }}</a> with a {{row.value.total_commits_count}} total number of commits  on gitlab
            </span>
            <span v-else-if=" row.verb.display.en ==='GITLAB_merge_request_EVENT'">
               raised a merge request
                {{ row.value.title }}
                  on gitlab that
                   {{ row.value.merge_status }}
            </span>
            <span v-else-if=" row.verb.display.en ==='NOTED'">
               noted
                {{ row.note }}
            </span>
            {{  timesAgo(row.timestamp.machineReadable) }}</td>
        </tr>
    </tbody>
  </v-table>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';

export default {
  name: 'HistoryEvents',
  methods: {
    ...mapActions({
      eventsDumpFetch: 'eventsDumpFetch',
    }),
    timesAgo(date) {
      if (date) return moment(date).fromNow();
      return '';
    },
  },
  data() {
    return {
      allEvents: [],
      filters: {
        actor: { value: '', keys: ['actor.username'] },
        verb: { value: '', keys: ['verb'] },
        value: { value: '', keys: ['value.*'] },
      },
      settings: {
        showJson: false,
      },
    };
  },

  computed: {

  },
  sockets: {
    connect() {
      console.log('socket connected');
    },
    newNotification(message) {
      const msg = JSON.parse(message);
      // console.log(message);
      if (msg.verb.display.en) {
        this.eventsDumpFetch();
      }
    },
  },

  mounted() {
    this.eventsDumpFetch();
    this.unsubscribe = this.$store.subscribe((mutation) => {
      // console.log({ mutation, state });
      if (mutation.type === 'SET_EVENTS_RAW_LOG') {
        const { eventsRaw } = this.$store.state;
        this.allEvents = eventsRaw;
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
};
</script>

<style lang="scss" scoped>
.filter-wrapper {
  padding: 0.5em 1em;
}
table tr td:nth-child(4) {
  word-break: break-word;
}
  th svg path {
    fill: #000;
  }

  .filter-container {
    display: flex;
    flex-direction: row;
    gap: 5em;
  }

  .filter-settings {
    display: flex;
    padding: 1em 0;
    align-items: center;
  }
</style>
